import { createSvgIcon } from "@material-ui/core";
import type { ComponentsProps } from "@material-ui/core/styles/props";

// TOOD: Move this to shared icons
const ChevronDownIcon = createSvgIcon(
  <path d="M6.31408 9.31093C6.113 9.50954 6 9.77918 6 10.0604C6 10.3416 6.113 10.6112 6.31408 10.8098L11.2429 15.6891C11.6617 16.1036 12.3382 16.1036 12.757 15.6891L17.6859 10.8098C18.1047 10.3952 18.1047 9.72551 17.6859 9.31093C17.2671 8.89636 16.5906 8.89636 16.1718 9.31093L11.9946 13.4355L7.82817 9.31093C7.40938 8.89636 6.72213 8.90699 6.31408 9.31093Z" />,
  "ChevronDownIcon",
);

export const PROPS = {
  MuiButtonBase: {
    disableRipple: true,
  },
  MuiSelect: {
    IconComponent: ChevronDownIcon,
  },
  MuiTextField: {
    variant: "outlined",
  },
  MuiButton: {
    variant: "contained",
  },
  MuiCheckbox: {
    color: "primary",
  },
  MuiInput: {
    disableUnderline: true,
  },
  MuiTabs: {
    textColor: "primary",
    indicatorColor: "primary",
  },
} satisfies ComponentsProps;
